import httpClient from '../httpClient';

const newsletter = 'newsletter';

const subscribe = () => {
  return httpClient.post(`${newsletter}/subscribe`);
};

const unsubscribe = () => {
  return httpClient.post(`${newsletter}/unsubscribe`);
};

export default {
  subscribe,
  unsubscribe,
};
